"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPListMethods = exports.fixedLengthIter = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var Term_1 = require("../../../Term/index.js");
var type_system_1 = require("../../../type_system/index.js");
var tyArgs_1 = require("../../../type_system/tyArgs/index.js");
var utils_1 = require("../../../type_system/utils.js");
var list_1 = require("../../builtins/list/index.js");
var pprepend_1 = require("../../builtins/pprepend/index.js");
var pappArg_1 = require("../../pappArg.js");
var phoist_1 = require("../../phoist.js");
var plet_1 = require("../../plet/index.js");
var PMaybe_1 = require("../PMaybe/PMaybe.js");
var combinators_1 = require("../combinators/index.js");
var pevery_1 = require("../list/pevery.js");
var pfilter_1 = require("../list/pfilter.js");
var pfind_1 = require("../list/pfind.js");
var pindexList_1 = require("../list/pindexList.js");
var plength_1 = require("../list/plength.js");
var pmap_1 = require("../list/pmap/index.js");
var preverse_1 = require("../list/preverse.js");
var psome_1 = require("../list/psome.js");
var list_2 = require("../list/index.js");
var punsafeConvertType_1 = require("../../punsafeConvertType/index.js");
var BaseUtilityTerm_1 = require("./BaseUtilityTerm.js");
function fixedLengthIter(list, maxLength) {
    var i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!Number.isSafeInteger(maxLength))
                    throw new Error("max length for 'fixedLengthIterable' is not an integer");
                if (maxLength < 0)
                    maxLength = -maxLength;
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < maxLength)) return [3 /*break*/, 4];
                return [4 /*yield*/, list.head];
            case 2:
                _a.sent();
                list = list.tail;
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.fixedLengthIter = fixedLengthIter;
var flippedPrepend = function (t) { return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(t), t, (0, type_system_1.list)(t)).$((0, pprepend_1.pprepend)(t))); };
var flippedFind = function (t) { return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(t), (0, type_system_1.lam)(t, type_system_1.bool), (0, type_system_1.struct)({
    Just: { val: t },
    Nothing: {}
})).$((0, pfind_1.pfind)(t))); };
var flippedFilter = function (t) { return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(t), (0, type_system_1.lam)(t, type_system_1.bool), (0, type_system_1.list)(t)).$((0, pfilter_1.pfilter)(t))); };
var flippedEvery = function (t) { return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(t), (0, type_system_1.lam)(t, type_system_1.bool), type_system_1.bool).$((0, pevery_1.pevery)(t))); };
var flippedSome = function (t) { return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(t), (0, type_system_1.lam)(t, type_system_1.bool), type_system_1.bool).$((0, psome_1.psome)(t))); };
var getterOnly = {
    set: function () { },
    configurable: false,
    enumerable: true
};
function addPListMethods(_lst) {
    var elemsT = (0, tyArgs_1.getElemsT)(_lst.type);
    // this clone is causing problems for aliases
    // TODO: remove clone and test
    /** @todo remove clone and test */
    var lst = new Term_1.Term((0, type_system_1.list)(elemsT), 
    // needs to be wrapped to prevent the garbage collector to collect garbage (lst)
    function (dbn) { return _lst.toIR(dbn); }, _lst.isConstant);
    if (!(0, type_system_1.isWellFormedGenericType)(elemsT)) {
        throw new Error("`addPListMethods` can only be used on lists with concrete types; the type of the lst was: " + (0, utils_1.termTypeToString)(lst.type));
    }
    _definePListMethods(lst, elemsT);
    _definePListMethods(_lst, elemsT);
    return lst;
}
exports.addPListMethods = addPListMethods;
function _definePListMethods(lst, elemsT) {
    lst = (0, BaseUtilityTerm_1.addBaseUtilityTerm)(lst);
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "fixedLengthIterable", 
    // as type conversion is fine because this is a funciton
    // and will only always be accessed after this function has
    // defined the necessary methods for "TermList" to be satisfied
    function (max) { return fixedLengthIter(lst, max); });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "head", __assign({ get: function () {
            return (0, plet_1.plet)((0, punsafeConvertType_1.punsafeConvertType)((0, list_1.phead)(elemsT).$(lst), elemsT), "list::head");
        } }, getterOnly));
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "tail", __assign({ get: function () { return (0, plet_1.plet)((0, list_1.ptail)(elemsT).$(lst), "list::tail"); } }, getterOnly));
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "length", __assign({ get: function () { return (0, plet_1.plet)((0, plength_1.plength)(elemsT).$(lst), "list::length"); } }, getterOnly));
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "reversed", __assign({ get: function () { return (0, plet_1.plet)((0, preverse_1.preverse)(elemsT).$(lst), "list::reversed"); } }, getterOnly));
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pat", __assign({ get: function () { return (0, pindexList_1.pindexList)(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "at", function (index) { return (0, pindexList_1.pindexList)(elemsT).$(lst).$(index); });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pfind", __assign({ get: function () { return flippedFind(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "find", function (predicate) {
        return (0, pfind_1.pfind)(elemsT).$(predicate).$(lst);
    });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pfilter", __assign({ get: function () { return flippedFilter(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "filter", function (predicate) {
        return (0, pfilter_1.pfilter)(elemsT).$(predicate).$(lst);
    });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pprepend", __assign({ get: function () { return flippedPrepend(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "prepend", function (elem) { return (0, pprepend_1.pprepend)(elemsT).$(elem).$(lst); });
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "pmap", function (toType) {
        return (0, phoist_1.phoist)((0, combinators_1.pflip)((0, type_system_1.list)(elemsT), (0, type_system_1.lam)(elemsT, toType), (0, type_system_1.list)(toType)).$((0, pmap_1.pmap)(elemsT, toType)))
            .$(lst);
    });
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "map", function (f) {
        f = (0, pappArg_1.pappArgToTerm)(f, (0, type_system_1.lam)(elemsT, (0, type_system_1.tyVar)()));
        var predicateTy = f.type;
        if (!(predicateTy[0] === type_system_1.PrimType.Lambda &&
            (0, type_system_1.isWellFormedGenericType)(predicateTy[2])))
            throw new Error("can't map plu-ts fuction of type \"".concat(predicateTy, "\" over a lst of type \"lst(").concat((0, utils_1.termTypeToString)(elemsT), ")\""));
        return (0, pmap_1.pmap)(elemsT, predicateTy[2]).$(f).$(lst);
    });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pevery", __assign({ get: function () { return flippedEvery(elemsT)
            .$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "every", function (predicate) { return (0, pevery_1.pevery)(elemsT).$(predicate).$(lst); });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "psome", __assign({ get: function () { return flippedSome(elemsT)
            .$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "some", function (predicate) { return (0, psome_1.psome)(elemsT).$(predicate).$(lst); });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "pincludes", __assign({ get: function () { return (0, list_2.pincludes)(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "includes", function (elem) { return (0, list_2.pincludes)(elemsT).$(lst).$(elem); });
    (0, obj_utils_1.definePropertyIfNotPresent)(lst, "peq", __assign({ get: function () { return (0, list_2.peqList)(elemsT).$(lst); } }, getterOnly));
    (0, obj_utils_1.defineReadOnlyProperty)(lst, "eq", function (other) { return (0, list_2.peqList)(elemsT).$(lst).$(other); });
    if ((0, type_system_1.typeExtends)(elemsT, (0, type_system_1.pair)((0, type_system_1.tyVar)(), (0, type_system_1.tyVar)()))) {
        var kT_1 = (0, tyArgs_1.getFstT)(elemsT);
        var vT_1 = (0, tyArgs_1.getSndT)(elemsT);
        var PMaybeVal_1 = (0, PMaybe_1.PMaybe)(vT_1);
        (0, obj_utils_1.definePropertyIfNotPresent)(lst, "plookup", __assign({ get: function () { return (0, combinators_1.pflip)((0, type_system_1.list)(elemsT), kT_1, PMaybeVal_1.type).$((0, list_2.plookup)(kT_1, vT_1)).$(lst); } }, getterOnly));
        (0, obj_utils_1.defineReadOnlyProperty)(lst, "lookup", function (key) { return (0, list_2.plookup)(kT_1, vT_1).$(key).$(lst); });
    }
    return lst;
}
